/**
 * Μαζεύει όλα τα stores και τα βάζει μέσα στο RootStore
 */
import { create } from 'mobx-persist';

import { log } from 'shared-pages/services';
import { AppStore, PERSIST_APP_STORE_KEY } from './app-store';
import { AuthStore } from './auth-store';
// import { TableStore } from 'table-v8/table-store';
import { MotionUIStore, TableStore, registerMotionUIStore } from 'motion-components';

export { PERSIST_APP_STORE_KEY };

export class RootStore {
  appStore = new AppStore();
  authStore = new AuthStore(this.appStore);
  tableStore = new TableStore();
  motionUIStore = new MotionUIStore();

  constructor() {
    // Δηλώνει το shared UI store πριν γίνουν render τα motion-components.
    registerMotionUIStore(this.motionUIStore);
    // const hydrate = create({ storage: sessionStorage });
    // const hydrate = create({ storage: localStorage });

    const hydrate = create({ storage: localStorage });
    hydrate(PERSIST_APP_STORE_KEY, this.appStore).then(() => {
      log.log('[RootStore] AppStore has been hydrated');
      this.appStore.initialize();
    });
  }
}
